<template>
	<v-btn
		v-bind="$props"
		color="primary"
		class="px-10 text-none secondary-action-button"
		:class="getQaSelectorClass()"
		outlined
		:data-testid="testId"
		v-on="$listeners"
	>
		<slot />
	</v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib'

export default {
	name: 'secondary-action-button',
	extends: VBtn,
	props: {
		testId: {
			type: String,
			default: 'cassie_secondaryactionbutton'
		}
	},
	methods: {
		getQaSelectorClass () {
			const buttonText = this.$slots.default.find(({ text }) => text).text.trim().replace(/\s/g, '-').toLowerCase()
			return `qa-primaryactionbutton-${buttonText}`
		}
	}
}
</script>

<style lang="scss">
	// Add hover lift effect to secondary action buttons
	.v-btn.secondary-action-button {
		transition: all 0.3s ease;

		&:hover:not(:disabled) {
			transform: translateY(-2px);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
		}
	}
</style>
